// Native
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";

// Imported
import {NgbPaginationConfig} from "@ng-bootstrap/ng-bootstrap";

// Modules, services, components
import {AuthService} from "../../services/auth.service";
import {FormService} from "../../services/form.service";
import {ValidateService} from "../../modules/validate/validate.service";
import {BroadcastService} from "../../services/broadcast.service";
import Pagination from './pagination';

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  inputs: ['itemsOnPage', 'itemsFull', 'page', 'class'],
  providers: [NgbPaginationConfig]
})
export class PaginationComponent implements OnInit {

  classCard: string;
  paginationForm: FormGroup;
  pageLimit: number; // Количество объектов на странице
  currentPage: number; // Текущая страница в пагинации
  collectionSize: number; // Количество элементов
  maxSize: number = 3;
  pageLimitItems: any[] = [50, 100];
  pagesNum: number; // Количество страниц
  skipItems: number; // Количество пропущенных объектов на определенной странице
  subscription: any;
  subscriptionViewChangePage: any;
  subscriptionCardFilter: any;
  subscriptionCustomFilter: any;
  pagination = new Pagination();
  visible: boolean = false;

  /**
   * itemsOnPage...Элементов на странице
   * itemsFull.....Общее кол-во элементов
   * page..........Текущая страница
   */

  @Input('itemsOnPage')
  set itemsOnPage(value: number) { // Принимаем количество объектов на странице с родительского компонента
    this.pageLimit = value;
    let idx = this.pageLimitItems.indexOf(this.pageLimit);
    if (idx > -1)
      this.pagination.limit = this.pageLimit;
    else
      this.pagination.limit = this.pageLimitItems[0];
    this.setPagesNum();
  }


  @Input('itemsFull')
  set itemsFull(value: number) { // Принимаем количество всего объектов с родительского компонента
    this.collectionSize = value;
    // this.pageLimitItems[this.pageLimitItems.length - 1] = value;
    this.setPagesNum();
  }

  @Input('page')
  set page(value: number) { // Принимаем текущую страницу c родительского компонента
    this.currentPage = value;
    this.setPage(this.currentPage);
  }


  @Input('class')
  set class(value: string) { // Принимаем текущую страницу c родительского компонента
    this.classCard = value;
  }

  @Input() offsetTop: boolean = true;

  @Output() pageChanged: EventEmitter<Pagination> = new EventEmitter<Pagination>();

  constructor(public broadcastService: BroadcastService,
              private _authService: AuthService,
              private _validate: ValidateService,
              private _form: FormService) {
    this.initPaginationForm();
  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  initPaginationForm() {
    this.paginationForm = new FormGroup({
      setPage: new FormControl('', [
        Validators.pattern(RegExp(this._validate.validateNumber().regex)),
        Validators.min(1),
        Validators.max(this.pagesNum)
      ])
    });
  }

  isSelected(a: any, b: any) {
    return a.id === b.id
  }

  setCurrentPage(form) {
    if (form.valid && form.enabled) {
      this.currentPage = form.value.setPage;
      this.setPage(this.currentPage);
    }

  }

  setPage(page: number, paginationForm?: any) {
    this.pagination.skip = this.pageLimit * (page - 1);

    this.pageChanged.emit(this.pagination);
  }

  setPagesNum() {
    this.visible = this.collectionSize > this.pageLimit;
    this.pagesNum = Math.ceil(this.collectionSize / this.pageLimit);
  }

  setPageLimit(limit: any) {
    let oldLimit = this.pageLimit;

    if(limit == 'All') {
      this.pageLimit = this.collectionSize;
    } else if(!limit){
      this.pageLimit = 20;
    } else{
      this.pageLimit = limit;
    }

    this.currentPage = Math.ceil(this.pagination.skip / this.pageLimit) || 1;

    this.pagination.limit = this.pageLimit;

    this.setPage(this.currentPage);
  }

  reset() {
    this.pagination.skip = 0;
    this.currentPage = 1;
  }

}
